import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OpusEditor.html?raw';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import Edit from '../../../moreCore/UI/Edit/Edit';
import "../../../moreCore/UI/Edit/Edit";
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import "../../../moreCore/UI/NumberInput/NumberInput";
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import VoiceAttributeEditForm from '../../VoiceAttributeEditForm/VoiceAttributeEditForm';
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import { ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import OpusAddressEditForm from './OpusAddressEditForm/OpusAddressEditForm';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';


class OpusEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    opusID: string;
    opusDisplayName: string;
    
    as_opus_titel_D: MdsLax<InstanceType<typeof Edit>>; //Disabled
    as_opus_subtitel_D: MdsLax<InstanceType<typeof Edit>>; 
    as_opus_calling_name_D: MdsLax<InstanceType<typeof Edit>>;
    as_opus_titel_original: MdsLax<InstanceType<typeof Edit>>;
    as_opus_info_text_html: MdsLax<InstanceType<typeof Edit>>; //MultiLine -> HTML Editor when implemented
    as_opus_info_text_html_E: MdsLax<InstanceType<typeof Edit>>; //MultiLine -> HTML Editor when implemented
    as_duration_min: MdsLax<InstanceType<typeof NumberInput>>;
    //GROUP START
    as_note: MdsLax<InstanceType<typeof Edit>>; //MultiLine
    as_note_special: MdsLax<InstanceType<typeof Edit>>; //Multiline
    as_movements: MdsLax<InstanceType<typeof Edit>>; //Multiline
    as_opus_first_realease: MdsLax<InstanceType<typeof Edit>>; //MultiLine
    //GROUP END
    //GROUP START
    as_created_from: MdsLax<InstanceType<typeof Edit>>;
    as_created_until: MdsLax<InstanceType<typeof Edit>>;
    as_created_about: MdsLax<InstanceType<typeof Edit>>;
    //GROUP END

    as_EL_ht_addresses_opus_opus_store: MdsLax<InstanceType<typeof EntityStore<MainCatalogTypes.RelatedAddressTableEntry>>>;

    newAddressComposerHintbox: MdsLax<InstanceType<typeof HintBox>>;
    newAddressFunctionSelect: MdsLax<InstanceType<typeof SearchSelect>>;
    relatedAddressTable: MdsLax<InstanceType<typeof StaticTable>>;
    opusAddressEditForm: MdsLax<InstanceType<typeof OpusAddressEditForm>>;


    expandableSectionVoiceAttributeForm: MdsLax<InstanceType<typeof ExpandableSection>>;
    voiceAttributeEditForm: MdsLax<InstanceType<typeof VoiceAttributeEditForm>>;
    voiceAttributeEditFormContainer: HTMLDivElement;

    editMainContainer: HTMLDivElement;
    relatedAdressTableContainer: HTMLDivElement;

    dlg: MdsLax<InstanceType<typeof GenericDialog>>;

    errorMessage: HTMLDivElement;
    errorContainer: HTMLDivElement;

    
    //Related Address Table
    private _setupAddress(data?: Array<MainCatalogTypes.RelatedAddressTableEntry>): void {
        this.as_EL_ht_addresses_opus_opus_store.on("change", lang.hitch(this, this._onChangeOpusInputData));
        this.setupTable();
    }

    private _setAddressTableData(data?: Array<MainCatalogTypes.RelatedAddressTableEntry>) {
        if (data) {
            this.as_EL_ht_addresses_opus_opus_store.setup(data);
        } else {
            this.as_EL_ht_addresses_opus_opus_store.setup(new Array<MainCatalogTypes.RelatedAddressTableEntry>())
        }
        this.relatedAddressTable.setupFromStore(this.as_EL_ht_addresses_opus_opus_store);
    }

    private setupTable(): void {
        this.relatedAddressTable = new StaticTable();
        this.newAddressFunctionSelect.loadListValues();
        this.relatedAddressTable.setRowClick(lang.hitch(this, this._onClickRow));
        this.relatedAddressTable.addLineConfig(this.relatedAddressTableLayout);
        this.relatedAddressTable.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditRelatedAddress));
        this.relatedAddressTable.addDefaultRowActionButton("delete", lang.hitch(this, this._onClickDeleteRelatedAddress));
        this.relatedAddressTable.setCyAttribute("OpusEditorRelatedAddressTable");
        this.UiModder.domConstruct.place(this.relatedAddressTable.domNode, this.relatedAdressTableContainer);
    }

    private relatedAddressTableLayout: StaticTable.RowConfig = {
        colNamesInternal: ["ref_opus.gDisp_opus", "ref_address.gDisp_Firstname_Name", "ref_relation_type.description"],
        "attributes": ["ref_opus.gDisp_opus", "ref_address.gDisp_Firstname_Name", "ref_relation_type.description"],
        "colspans": [1, 1, 1],
        "headings": ["Werkbezeichnung", "Anzeigename", "Funktion"],
        widths: [null, null, null],
        alignmentsHeading: [null, null, null],
        alignmentsRow: [null, null, null]
    };

    private _onClickRow(row: StaticTable.StaticTableRow<MainCatalogTypes.RelatedAddressTableEntry>) {
        this._openEditForm(row.rowGroup.entity);   
    }

    private _onClickEditRelatedAddress(rowGroup: StaticTable.StaticTableRowGroup<MainCatalogTypes.RelatedAddressTableEntry>): void {
        this._openEditForm(rowGroup.entity);
    }

    private _openEditForm(entry: MainCatalogTypes.RelatedAddressTableEntry) {
        this.dlg = new GenericDialog();


        this.dlg.closeOnEnter = false;
        this.dlg.destroyOnClose = true;
        this.dlg.keepOpen = true;
        this.dlg.enableContentOverflow(true);

        this.opusAddressEditForm = new OpusAddressEditForm();
        this.opusAddressEditForm.setupForm(entry);

        this.dlg.show(this.opusAddressEditForm, entry.ref_address.gDisp_Firstname_Name, null, null, "okcancel", lang.hitch(this, this._onOpusAddressEditFormDlgResponse, this.dlg, this.opusAddressEditForm));
    }

    private _onOpusAddressEditFormDlgResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof OpusAddressEditForm>>, response: number) {
        if (response >= 1) {
            var formData = form.getData();
            if (form.getIsDirty()) {
                this.as_EL_ht_addresses_opus_opus_store.changeEntry(formData);
            }
        }
        dlg.close(-1, true);
    }

    private _onClickDeleteRelatedAddress(e: StaticTable.StaticTableRowGroup<MainCatalogTypes.RelatedAddressTableEntry>): void {
        this.as_EL_ht_addresses_opus_opus_store.deleteEntry(e.entity);
    }

    private _onClickAddAddress(): void {
        var newRelatedAddress: MainCatalogTypes.RelatedAddressTableEntry = {
            ID: null,
            ref_opus: {
                ID: this.opusID,
                gDisp_opus: this.opusDisplayName,
            },
            ref_address: this.newAddressComposerHintbox.getValue("entity"),
            ref_relation_type: this.newAddressFunctionSelect.getValue(true),
            order: null
        }
        this.as_EL_ht_addresses_opus_opus_store.addEntry(newRelatedAddress);
    }

    //Voice Attribute Editor
    private _setupVoiceAttributeEditor(entity?: VAM2types.VoiceAttributes) {
        this.voiceAttributeEditForm = new VoiceAttributeEditForm();
        this.voiceAttributeEditForm.setStartupState("ready");
        this.voiceAttributeEditForm.on("change", lang.hitch(this, this._onChangeOpusInputData));
        this.expandableSectionVoiceAttributeForm.setup(this.voiceAttributeEditForm.domNode, this.translate("OpusEditor_Label_Instrumentation"), "medium");
        this.UiModder.domConstruct.place(this.voiceAttributeEditForm.domNode, this.voiceAttributeEditFormContainer);
        this.expandableSectionVoiceAttributeForm.setMarking(ExpandableSectionMarkings.hasContent);
    }

    private _setVoiceAttributeEditorData(data?: VAM2types.VoiceAttributes) {
        if (data) {
            this.voiceAttributeEditForm.setData(data);
        } else {
            this.voiceAttributeEditForm.setData(this._setupEmptyVoiceAttributeData());
        }
    }

    //Data processing
    formData: MainCatalogTypes.Opus_SaveData = (this as any)._setupEmptyFormData();

    private _setupEmptyFormData(): MainCatalogTypes.Opus_SaveData {
        let formData = {};

        formData["ID"] = "";
        formData["opus_titel_D"] = "";
        formData["opus_subtitel_D"] = "";
        formData["opus_calling_name_D"] = "";
        formData["opus_titel_original"] = "";
        formData["opus_info_text_html"] = "";
        formData["opus_info_text_html_E"] = "";
        formData["duration_min"] = null;
        formData["note"] = "";
        formData["note_special"] = "";
        formData["movements"] = "";
        formData["opus_first_release"] = "";
        formData["isNew"] = null;
        
        for (let i = 1; i < 19;  i++) {
            formData[`instrumentation_group${i}_number_str`] = "";
            formData[`instrumentation_group${i}_number`] = 0;
            formData[`is_oversteered_instrumentation_group${i}_number`] = "";
            formData[`is_oversteered_instrumentation_group${i}_comment`] = null;
            formData[`instrumentation_group${i}_comment`] = "";
        }
        return formData as MainCatalogTypes.Opus_SaveData;
    }

    private _setupEmptyVoiceAttributeData(): VAM2types.VoiceAttributes {
        let voiceAttributeData = {};

        for (let i = 1; i < 19; i++) {
            voiceAttributeData[`instrumentation_group${i}_number_str`] = "";
            voiceAttributeData[`instrumentation_group${i}_number`] = 0;
            voiceAttributeData[`is_oversteered_instrumentation_group${i}_number`] = "";
            voiceAttributeData[`is_oversteered_instrumentation_group${i}_comment`] = null;
            voiceAttributeData[`instrumentation_group${i}_comment`] = "";
        }
        return voiceAttributeData as VAM2types.VoiceAttributes;
    }

    prepareFormData(data?: MainCatalogTypes.Opus_LoadData): void {   
        if (data) {
            console.log(data);
            this.opusID = data.ID;
            this.opusDisplayName = data.gDisp_opus;

            this.as_opus_titel_D.setValue(data.opus_titel_D, true);
            this.as_opus_subtitel_D.setValue(data.opus_subtitel_D, true);
            this.as_opus_calling_name_D.setValue(data.opus_calling_name_D, true);
            this.as_opus_titel_original.setValue(data.opus_titel_original, true);
            this.as_opus_info_text_html.setValue(data.opus_info_text_html, true);
            this.as_opus_info_text_html_E.setValue(data.opus_info_text_html_E, true);
            this.as_duration_min.setValue(data.duration_min, true);
            this.as_note.setValue(data.note, true);
            this.as_note_special.setValue(data.note_special, true);
            this.as_movements.setValue(data.movements, true);
            this.as_opus_first_realease.setValue(data.opus_first_release, true);
            this.as_created_from.setValue(data.created_from, true);
            this.as_created_until.setValue(data.created_until, true);
            this.as_created_about.setValue(data.created_about, true);

            this._setAddressTableData(data.EL_ht_addresses_opus_opus);
            this._setVoiceAttributeEditorData(data);

            this.formData.is_new_status = false;
        } else {
            this.as_opus_titel_D.setValue("", true);
            this.as_opus_subtitel_D.setValue("", true);
            this.as_opus_calling_name_D.setValue("", true);
            this.as_opus_titel_original.setValue("", true);
            this.as_opus_info_text_html.setValue("", true);
            this.as_opus_info_text_html_E.setValue("", true);
            this.as_duration_min.setValue(null, true);
            this.as_note.setValue("", true);
            this.as_note_special.setValue("", true);
            this.as_movements.setValue("", true);
            this.as_opus_first_realease.setValue("", true);
            this.as_created_from.setValue("", true);
            this.as_created_until.setValue("", true);
            this.as_created_about.setValue("", true);

            this._setAddressTableData();
            this._setVoiceAttributeEditorData();

            this.formData.is_new_status = true;
        }

        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(): void {
        this.formData.ID = this.opusID;
        this.formData.opus_titel_D = this.as_opus_titel_D.getValue();
        this.formData.opus_subtitel_D = this.as_opus_subtitel_D.getValue();
        this.formData.opus_calling_name_D = this.as_opus_calling_name_D.getValue();
        this.formData.opus_titel_original = this.as_opus_titel_original.getValue();
        this.formData.opus_info_text_html = this.as_opus_info_text_html.getValue();
        this.formData.opus_info_text_html_E = this.as_opus_info_text_html_E.getValue();
        this.formData.duration_min = this.as_duration_min.getValue();
        this.formData.note = this.as_note.getValue();
        this.formData.note_special = this.as_note_special.getValue();
        this.formData.movements = this.as_movements.getValue();
        this.formData.opus_first_release = this.as_opus_first_realease.getValue();
        this.formData.created_from = this.as_created_from.getValue();
        this.formData.created_until = this.as_created_until.getValue();
        this.formData.created_about = this.as_created_about.getValue();

        this._serializeRelatedAddressFormData();
        this._serializeVoiceAttributeFormData();

        console.debug("SERIALIZED DATA", this.formData);
    }

    private _serializeVoiceAttributeFormData(): void {
        let updatedOpus = this.voiceAttributeEditForm.getCurrentData();

        for (let i = 1; i < 19; i++) {
            this.formData[`instrumentation_group${i}_number_str`] = updatedOpus[`instrumentation_group${i}_number_str`].toString();
            this.formData[`instrumentation_group${i}_number`] = updatedOpus[`instrumentation_group${i}_number`];
            this.formData[`is_oversteered_instrumentation_group${i}_number`] = updatedOpus[`is_oversteered_instrumentation_group${i}_number`];
            this.formData[`is_oversteered_instrumentation_group${i}_comment`] = updatedOpus[`is_oversteered_instrumentation_group${i}_comment`];
            this.formData[`instrumentation_group${i}_comment`] = updatedOpus[`instrumentation_group${i}_comment`];
        }
    }


    private _serializeRelatedAddressFormData(): void {
        this.formData.El_ht_addresses_opus_opus = this.as_EL_ht_addresses_opus_opus_store.getCurrentCompleteList();
        this.formData.EL_ht_addresses_opus_opus_diffData = this.as_EL_ht_addresses_opus_opus_store.getDiffData();
    }

    showError(error: string): void {
        this.errorMessage.innerText = error;
        this.UiModder.domClass.remove(this.errorContainer, "w3-hide");
    }

    private _clearError(errorContainer): void {
        this.errorMessage.innerText = "";
        this.UiModder.domClass.add(this.errorContainer, "w3-hide");
    }

    isValid(): boolean {
        var valid: boolean = true;

        if (!this.as_opus_titel_D.getValue() || this.as_opus_titel_D.getValue().length < 0) {
            this.showError(this.translate("OpusEditor_Error_NoTitle"));
            valid = false;
        } else if (this.as_opus_titel_D.getValue().length > 255) {
            valid = false;
            this.showError(this.translate("OpusEditor_Error_TitleTooLong"));
        }

        if (this.as_opus_subtitel_D.getValue() && this.as_opus_subtitel_D.getValue().length > 100) {
            this.showError(this.translate("OpusEditor_Error_SubTitleTooLong"));
            valid = false;
        }
        if (this.as_opus_calling_name_D.getValue() && this.as_opus_calling_name_D.getValue().length > 100) {
            this.showError(this.translate("OpusEditor_Error_CallingNameTooLong"));
            valid = false;
        }
        if (this.as_opus_titel_original.getValue() && this.as_opus_titel_original.getValue().length > 100) {
            this.showError(this.translate("OpusEditor_Error_OriginalTitleTooLong"));
            valid = false;
        }
        if (this.as_opus_info_text_html.getValue() && this.as_opus_info_text_html.getValue().length > 100000) {
            this.showError(this.translate("OpusEditor_Error_InfoTextHtmlTooLong"));
            valid = false;
        }
        if (this.as_opus_info_text_html_E.getValue() && this.as_opus_info_text_html_E.getValue().length > 100000) {
            this.showError(this.translate("OpusEditor_Error_InfoTextHtmlETooLong"));
            valid = false;
        }
        if (this.as_note.getValue() && this.as_note.getValue().length > 2000) {
            this.showError(this.translate("OpusEditor_Error_NoteTooLong"));
            valid = false;
        }
        if (this.as_note_special.getValue() && this.as_note_special.getValue().length > 2000) {
            this.showError(this.translate("OpusEditor_Error_NoteSpecialTooLong"));
            valid = false;
        }
        if (this.as_movements.getValue() && this.as_movements.getValue().length > 2000) {
            this.showError(this.translate("OpusEditor_Error_MovementsTooLong"));
            valid = false;
        }
        if (this.as_opus_first_realease.getValue() && this.as_opus_first_realease.getValue().length > 255) {
            this.showError(this.translate("OpusEditor_Error_FirstReleaseTooLong"));
            valid = false;
        }
        if (this.as_created_from.getValue() && this.as_created_from.getValue().length > 4) {
            this.showError(this.translate("OpusEditor_Error_CreatedFromTooLong"));
            valid = false;
        }
        if (this.as_created_until.getValue() && this.as_created_until.getValue().length > 4) {
            this.showError(this.translate("OpusEditor_Error_CreatedUntilTooLong"));
            valid = false;
        }
        if (this.as_created_about.getValue() && this.as_created_about.getValue().length > 50) {
            this.showError(this.translate("OpusEditor_Error_CreatedAboutTooLong"));
            valid = false;
        }

        return valid;
    }

    private _onChangeOpusInputData(): void {
        this.serializeFormData();
        this.checkDirty();
    }



    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.Opus;
        this.as_EL_ht_addresses_opus_opus_store = new EntityStore();

        this._setupVoiceAttributeEditor();
        this._setupAddress();

        this.on("CatalogEntityData_Save", lang.hitch(this, this._clearError));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(OpusEditor);
